import React from "react";
import Customers from "./Customers";

export default function WorkRoom() {
  return <Customers room />;
}
